var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleExclamationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.98 39.98a49.9 49.9 0 0 1 43.12 24.75l270.02 460.04c9.13 15.5 9.13 34.62.25 50.12s-25.5 25.13-43.37 25.13H49.96c-17.88 0-34.5-9.63-43.38-25.13s-8.75-34.75.25-50.12L276.85 64.72a49.9 49.9 0 0 1 43.13-24.75zm0 160.01c-16.63 0-30 13.38-30 30V370c0 16.63 13.37 30 30 30s30-13.37 30-30V230c0-16.63-13.38-30-30-30zm40 280.02c0-22.13-17.88-40-40-40s-40 17.87-40 40 17.87 40 40 40 40-17.87 40-40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamationSolid);
export default __webpack_public_path__ + "static/media/triangle-exclamation-solid.6e8dfcd60ae03a836b06cbed9473b373.svg";
export { ForwardRef as ReactComponent };